const OtpType = {
    Email: 1,
    Phone: 2
    
}

export default OtpType